<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import request from '@/services/request';

import ModalFormComponent from '../../components/bill_download/ModalFormComponent.vue';

import Pagination from 'vue-pagination-2';
// import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
	name: "bills-table",
	components: {
		ModalFormComponent,
		// DatePicker,
		Pagination,
	},
	data() {
		return {
            errors: {},
            form: {
                date: [],
                files: [],
            },
			order:{
				uuid:-1,
				date:-1,
				rfc:-1,
				name:-1,
				rfc_r:-1,
				amount:-1,
			},
			view: 0,
            send: false,
			total: 0,
			no_seal: 0,
			valid: 0,
			complements: 0,
			complements_no_save: 0,
			complements_no_parent: 0,
			saved: 0,
			not_saved: 0,
			no_xml: 0,
			no_company: 0,
			no_provider: 0,
			bills:[],
			bills_p:[],
			bills_s:[],
			bill: {},
			page: 1,
			per_page: 10,
		}
	},
	filters:{
		statusType(status){
			switch(status){
				case "validas":
				return "Conciliada Válida"
				case "complementos":
				return "Complemento de Pago"
				case "complemento_no_save":
				return "Complemento No Guardado"
				case "complemento_no_padre":
				return "Complemento Sin Factura Padre"
				case "guardadas":
				return "Facturas Guardadas";
				case "no_guardadas":
				return "Errores de Guardado"
				case "no_xml":
				return "Archivos No XML"
				case "no_company":
				return "Empresa no Encontrada"
				case "no_provider":
				return "Proveedor no Encontrado"
				case "no_sello":
				return "Sin Sello"
			}			
		} 
	},	
	async mounted() {
		this.last();
		this.setHeaderTitle('Procesar Facturas');
	},
	created() {

	},
	methods: {
        uploadFilesBill(event) {
            let vm = this;

            let droppedFiles = event.target.files;
            if (!droppedFiles) return;
            [...droppedFiles].forEach(function (valor) {
                vm.form.files.push(valor);
            });
            this.$forceUpdate();
        },
        dragFilesBill(event) {
            let vm = this;

            let droppedFiles = event.dataTransfer.files;
            if (!droppedFiles) return;
            [...droppedFiles].forEach(function (valor) {
                vm.form.files.push(valor);
            });
            this.$forceUpdate();
        },
        delImg(pos) {
            this.form.files.splice(pos, 1);
            this.successNotification('El archivo se elimino correctamente.');
        },
		maxDate(date) {
			const today = new Date();
			today.setHours(0, 0, 0, 0);

			return date > today;
		},
		paginateBills(){
			if(this.bills.length>0){
				let vm=this,k=0,j=1;
				this.bills_p[0]=[];
				this.bills.forEach(b=>{
					vm.bills_p[k].push(b);
					if(j%vm.per_page==0){
						k++;
						vm.bills_p[k]=[];
					}
					j++;
				});
				this.bills_s=this.bills_p[this.page-1];
			}else{
				this.bills_p=[];
				this.bills_s=[];
			}
		},
		async sendFiles() {
            this.send=true;
			this.total=0;
			this.no_seal=0;
			this.valid=0;
			this.complements=0;
			this.complements_no_save=0;
			this.complements_no_parent=0;
			this.saved=0;
			this.not_saved=0;
			this.no_xml=0;
			this.no_company=0;
			this.no_provider=0;
			this.bills=[];
			let data_form = new FormData(),vm=this;

			var _endpoint = `/bill_download_xml`,
				files=[],
				ind=0,
				count=1,
				i=0;
			if(this.view==0)
				data_form.append('date', this.form.date);
			else{
				files[0]=[];
				this.form.files.forEach(function (valor) {
					if(count%20==0){
						ind++;
						files[ind]=[];
					}
					files[ind][count++]=valor;
				});
				_endpoint = `/bill_download`;
			}

			while(i<=ind){
				if(this.view==1){
					data_form = new FormData();
					files[i].forEach(function (valor2, index2) {
						data_form.append('xmls[' + index2 + ']', valor2);
					})
				}
				try {
					let { data } = await request.postMedia(_endpoint, data_form)
					if (!data.ok) {
						var message='';
						if(this.view==0)
							message='No se pudieron descargar todas las facturas';
						else
							message='No se pudieron cargar todas las facturas';
						this.$swal({
							icon: 'error',
							title: message,
							text: data.errors.xmls[0]
						});
					}
					if(data.continue){
						this.total+=data.totales;
						this.no_seal+=data.no_sello;
						this.valid+=data.validas;
						this.complements+=data.complementos;
						this.complements_no_save+=data.complemento_no_save;
						this.complements_no_parent+=data.complemento_no_padre;
						this.saved+=data.guardadas;
						this.not_saved+=data.no_guardadas;
						this.no_xml+=data.no_xml;
						this.no_company+=data.no_company;
						this.no_provider+=data.no_provider;
						Object.keys(data.bills).forEach(index=>{
							data.bills[index].forEach(bill=>{
								vm.bills.push({
									type:index,
									uuid: bill.uuid,
									date: bill.date,
									rfc_r: bill.receptor,
									name: bill.name,
									rfc: bill.rfc,
									amount: bill.amount,
								})
							})
						});
					}
				} catch (error) {
					this.send = false;
					this.errors = {};
					if (error.response) {
						this.errors = await this.errorNotification(error);
					}
				} finally{
					i++;
				}
			}
			this.sortPage('date');
			this.list();
			this.form.files = [];
			this.last();
			this.send=false;
        },
		async last() {
			this.load = true;
			let service = request;
			let _endpoint = '/last_uploaded_bill';
			try {
				let { data } = await service.list(_endpoint)
				if (data) {
					this.bill = data;
					this.load = false;
				}
			} catch (error) {
				console.log(error);
				this.load = false;
			}
		},
		async sortPage(name){
			switch(name){
				case 'type':
					this.order.type++;
					if(this.order.type%2==0)
						this.bills=this.bills.sort((a,b)=>{
							return a.type.localeCompare(b.type)
						});
					else
						this.bills=this.bills.sort((a,b)=>{
							return b.type.localeCompare(a.type)
						});
					this.order.uuid=-1;
					this.order.date=-1;
					this.order.rfc=-1;
					this.order.name=-1;
					this.order.rfc_r=-1;
					this.order.amount=-1;
				break;
				case 'uuid':
					this.order.uuid++;
					if(this.order.uuid%2==0)
						this.bills=this.bills.sort((a,b)=>{
							return a.uuid.localeCompare(b.uuid)
						});
					else
						this.bills=this.bills.sort((a,b)=>{
							return b.uuid.localeCompare(a.uuid)
						});
					this.order.type=-1;
					this.order.date=-1;
					this.order.rfc=-1;
					this.order.name=-1;
					this.order.rfc_r=-1;
					this.order.amount=-1;
				break;
				case 'date':
					this.order.date++;
					if(this.order.date%2==0)
						this.bills=this.bills.sort((a,b)=>{
							return new Date(a.date) - new Date(b.date)
						});
					else
						this.bills=this.bills.sort((a,b)=>{
							return new Date(b.date) - new Date(a.date)
						});
					this.order.type=-1;
					this.order.uuid=-1;
					this.order.rfc=-1;
					this.order.name=-1;
					this.order.rfc_r=-1;
					this.order.amount=-1;
				break;
				case 'rfc':
					this.order.rfc++;
					if(this.order.rfc%2==0)
						this.bills=this.bills.sort((a,b)=>{
							return a.rfc.localeCompare(b.rfc)
						});
					else
						this.bills=this.bills.sort((a,b)=>{
							return b.rfc.localeCompare(a.rfc)
						});
					this.order.type=-1;
					this.order.uuid=-1;
					this.order.date=-1;
					this.order.name=-1;
					this.order.rfc_r=-1;
					this.order.amount=-1;
				break;
				case 'name':
					this.order.name++;
					if(this.order.name%2==0)
						this.bills=this.bills.sort((a,b)=>{
							return a.name.localeCompare(b.name)
						});
					else
						this.bills=this.bills.sort((a,b)=>{
							return b.name.localeCompare(a.name)
						});
					this.order.type=-1;
					this.order.uuid=-1;
					this.order.date=-1;
					this.order.rfc=-1;
					this.order.rfc_r=-1;
					this.order.amount=-1;
				break;
				case 'rfc_r':
					this.order.rfc_r++;
					if(this.order.rfc_r%2==0)
						this.bills=this.bills.sort((a,b)=>{
							return a.rfc_r.localeCompare(b.rfc_r)
						});
					else
						this.bills=this.bills.sort((a,b)=>{
							return b.rfc_r.localeCompare(a.rfc_r)
						});
					this.order.type=-1;
					this.order.uuid=-1;
					this.order.date=-1;
					this.order.rfc=-1;
					this.order.name=-1;
					this.order.amount=-1;
				break;
				case 'amount':
					this.order.amount++;
					if(this.order.amount%2==0)
						this.bills=this.bills.sort((a,b)=>{
							return a.amount - b.amount
						});
					else
						this.bills=this.bills.sort((a,b)=>{
							return b.amount - a.amount
						});
					this.order.type=-1;
					this.order.uuid=-1;
					this.order.date=-1;
					this.order.rfc=-1;
					this.order.name=-1;
					this.order.rfc_r=-1;
				break;
			}
			this.paginateBills();
		},
		async list(page = 1){
			this.bills_s=this.bills_p[page-1];
		},
		...mapMutations({
			setHeaderTitle: 'setHeaderTitle',
		}),
		...mapActions({
			resetPassword: 'auth/resetPass',
			errorNotification: 'alert/error',
			successNotification: 'alert/success',
		}),
	},
	watch: {
		'per_page': {
			handler: function () {
				this.paginateBills();
				this.page=1;
			},
			deep: true
		},
},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
}
</script>

<template>
	<div class="col-12">
		<div class="card card-outline card-navy">
			<div class="card-header">
				<h3 class="card-title" v-if="view==0">Descarga Autom&aacute;tica</h3>
				<h3 class="card-title" v-if="view==1">Carga Manual</h3>
				<br>
				<h3 class="card-title" v-if="bill.date_time && view==0 ">Última Descarga {{ bill.date_time | toDateTimeHour }}</h3>
				<h3 class="card-title" v-if="bill.date_time && view==1 ">Última Carga {{ bill.date_time | toDateTimeHour }}</h3>
			</div>
			<div class="card-body">
				<form @submit.prevent="sendFiles" method="post" enctype="multipart/form-data">
					<div class="row">
						<div class="col-md-12">
							<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
								<li class="nav-item">
									<a class="nav-link active" @click="view = 0" data-toggle="pill" role="tab"
										aria-selected="true">Descargar</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" @click="view = 1" data-toggle="pill" role="tab"
										aria-selected="false">Cargar</a>
								</li>
							</ul>
						</div>
					</div>
					<div class="row" v-if="view==0">
						<div class="col-md-12">
							<!-- <div class="col-md-5 col-lg-4">
								<label>Rango de fechas :</label>
								<date-picker format="YYYY-MM-DD" valueType="format" :range="true"
									v-model="form.date" :disabled-date="maxDate"></date-picker>
								<div v-if="init" class="text-danger">Periodo por Defecto</div>
							</div> -->
							<hr>
							<button :disabled="send" type="submit"
								class="btn float-right btn-outline-success">
								<span v-if="send">
									<i class="fa-solid fa-circle-notch fa-spin"></i> Procesando
								</span>
								<span v-else>
									<i class="fas fa-save"></i> Descargar
								</span>
							</button>
						</div>
					</div>
					<div class="row" v-if="view==1">
						<div class="col-12">
							<hr>
							<div class="row" v-if="!send">
								<div @dragover.prevent @drop.prevent class="col-12 text-center">
									<h3>Archivos adjuntos.</h3>
									<div @drop="dragFilesBill" class="row mt-4 mb-4">
										<div class="col-12" v-if="(form.files.length) == 0">
											<i class="fa-solid fa-file fa-4x"></i>
											<p>Sin archivos adjuntos</p>
										</div>
										<div class="col-md-4 col-12 p-2" v-for="(img, index_img) in form.files"
											:key="index_img" v-show="form.files.length > 0">
											<div>
												<button class="btn btn-sm btn-danger del" type="button"
													@click="delImg(index_img)"><i class="fa fa-trash"></i></button>
													<p>{{ img.name }}</p>
											</div>
										</div>
									</div>


									<div class="input-group mb-3"
										v-if="(form.files.length) <= 14">
										<div class="custom-file" @change="uploadFilesBill">
											<input type="file" multiple class="custom-file-input" id="inputGroupFile03"
												aria-describedby="inputGroupFileAddon03">
											<label class="custom-file-label" for="inputGroupFile03">
												Subir Archivo
											</label>
										</div>
									</div>


								</div>

							</div>
							<div v-else>
								<div class="row">
									<div class="col-12 text-center">
										<i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
										<h5>Cargando</h5>
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-12">
							<hr>
							<button :disabled="send" type="submit"
								class="btn float-right btn-outline-success">
								<span v-if="send">
									<i class="fa-solid fa-circle-notch fa-spin"></i> Procesando
								</span>
								<span v-else>
									<i class="fas fa-save"></i> Enviar
								</span>
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div v-if="total > 0">
			<div class="row">
				<div class="col-md-6 col-lg-4 col-sm-6 col-12">
					<div class="info-box shadow-sm">
						<div class="info-box-content">
							<span class="info-box-text">Procesadas</span>
							<span class="info-box-number">{{ total }}</span>
						</div>
						<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-upload"></i></span>
					</div>
				</div>
				<div v-if="saved > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
					<div class="info-box shadow-sm">
						<div class="info-box-content">
							<span class="info-box-text">Facturas Guardadas</span>
							<span class="info-box-number">{{ saved }}</span>
						</div>
						<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-download"></i></span>
					</div>
				</div>
				<div v-if="valid > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
					<div class="info-box shadow-sm">
						<div class="info-box-content">
							<span class="info-box-text">Conciliadas V&aacute;lidas</span>
							<span class="info-box-number">{{ valid }}</span>
						</div>
						<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-check-double"></i></span>
					</div>
				</div>
				<div v-if="complements > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
					<div class="info-box shadow-sm">
						<div class="info-box-content">
							<span class="info-box-text">Complementos de Pago</span>
							<span class="info-box-number">{{ complements }}</span>
						</div>
						<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-file-invoice-dollar"></i></span>
					</div>
				</div>
				<div v-if="no_seal > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
					<div class="info-box shadow-sm">
						<div class="info-box-content">
							<span class="info-box-text">Sin Sello</span>
							<span class="info-box-number">{{ no_seal }}</span>
						</div>
						<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-file-contract"></i></span>
					</div>
				</div>
				<div v-if="no_company > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
					<div class="info-box shadow-sm">
						<div class="info-box-content">
							<span class="info-box-text">Empresa no Encontrada</span>
							<span class="info-box-number">{{ no_company }}</span>
						</div>
						<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-times"></i></span>
					</div>
				</div>
				<div v-if="no_provider > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
					<div class="info-box shadow-sm">
						<div class="info-box-content">
							<span class="info-box-text">Proveedor no Encontrado</span>
							<span class="info-box-number">{{ no_provider }}</span>
						</div>
						<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-times"></i></span>
					</div>
				</div>
				<div v-if="complements_no_save > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
					<div class="info-box shadow-sm">
						<div class="info-box-content">
							<span class="info-box-text">Complementos No Guardados</span>
							<span class="info-box-number">{{ complements_no_save }}</span>
						</div>
						<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-hourglass-half"></i></span>
					</div>
				</div>
				<div v-if="complements_no_parent > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
					<div class="info-box shadow-sm">
						<div class="info-box-content">
							<span class="info-box-text">Complementos Sin Factura Padre</span>
							<span class="info-box-number">{{ complements_no_parent }}</span>
						</div>
						<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-hourglass-half"></i></span>
					</div>
				</div>
				<div v-if="not_saved > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
					<div class="info-box shadow-sm">
						<div class="info-box-content">
							<span class="info-box-text">Errores de Guardado</span>
							<span class="info-box-number">{{ not_saved }}</span>
						</div>
						<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-times"></i></span>
					</div>
				</div>
				<div v-if="no_xml > 0" class="col-md-6 col-lg-4 col-sm-6 col-12">
					<div class="info-box shadow-sm">
						<div class="info-box-content">
							<span class="info-box-text">Archivos No XML</span>
							<span class="info-box-number">{{ no_xml }}</span>
						</div>
						<span class="info-box-icon bg-navy rounded-circle"><i class="fa-solid fa-times"></i></span>
					</div>
				</div>
			</div>
		</div>
		<div class="card card-outline card-navy" v-if="total>0">
			<div class="card-body">
				<div class="row">
					<div class="col-md-6">
						<label>
							<ul class="nav nav-tabs" id="custom-tabs-one-tab" role="tablist">
								<li class="nav-item">
									<label class="nav-link">Resultados por P&aacute;gina:</label>
								</li>
								<li class="nav-item">
									<a class="nav-link active" @click="per_page = 10" data-toggle="pill" aria-selected="true">10</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" @click="per_page = 20" data-toggle="pill" aria-selected="false">20</a>
								</li>
								<li class="nav-item">
									<a class="nav-link" @click="per_page = 50" data-toggle="pill" aria-selected="false">50</a>
								</li>
							</ul>
						</label>
					</div>
				</div>
				<div class="table-responsive">
					<table class="table table-bordered text-center text-sm">
						<thead>
							<tr>
								<th>Tipo
									<button class="btn btn-xs" @click.prevent="sortPage('type')">
										<i class="fa" :class="order.type==-1?'fa-minus':(order.type%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>UUID
									<button class="btn btn-xs" @click.prevent="sortPage('uuid')">
										<i class="fa" :class="order.uuid==-1?'fa-minus':(order.uuid%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>Fecha Emisi&oacute;n
									<button class="btn btn-xs" @click.prevent="sortPage('date')">
										<i class="fa" :class="order.date==-1?'fa-minus':(order.date%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>RFC
									<button class="btn btn-xs" @click.prevent="sortPage('rfc')">
										<i class="fa" :class="order.rfc==-1?'fa-minus':(order.rfc%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>Raz&oacute;n Social
									<button class="btn btn-xs" @click.prevent="sortPage('name')">
										<i class="fa" :class="order.name==-1?'fa-minus':(order.name%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>RFC Receptor
									<button class="btn btn-xs" @click.prevent="sortPage('rfc_r')">
										<i class="fa" :class="order.rfc_r==-1?'fa-minus':(order.rfc_r%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
								<th>Monto
									<button class="btn btn-xs" @click.prevent="sortPage('amount')">
										<i class="fa" :class="order.amount==-1?'fa-minus':(order.amount%2==0?'fa-arrow-up':'fa-arrow-down')"></i>
									</button>
								</th>
							</tr>
						</thead>
						<tbody v-if="bills_s && bills_s.length > 0">
							<tr v-for="(billL, index) in bills_s" :key="index">
								<td>{{ billL.type | statusType }}</td>
								<td>{{ billL.uuid }}</td>
								<td>{{ billL.date | toDateTime }}</td>
								<td>{{ billL.rfc }}</td>
								<td>{{ billL.name }}</td>
								<td>{{ billL.rfc_r }}</td>
								<td>{{ billL.amount | toCurrency }}</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td align="center" colspan="9">Sin resultados.</td>
							</tr>
						</tbody>
					</table>
					<pagination v-model="page" :records="parseInt(total)" :per-page="parseInt(per_page)"
						@paginate="list" />
				</div>
			</div>
		</div>
		<ModalFormComponent/>
	</div>
</template>

<style scoped>
.pagination {
	margin-bottom: 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
	{
	opacity: 0;
}

.btn-xs {
  padding: 0.125rem 0.25rem;
  font-size: 0.70rem;
  line-height: 1.2;
}
</style>
